// Availability is an explicit server decision. An absent deadline alone never
// authorizes acquisition; coordinate and permit expiration remain independent.
export const isGoogleCheckoutAvailable = (value, now = Date.now()) => {
  if (value?.available !== true) return false;
  if (value.mode === 'continuous') return value.endsAt === null;
  if (value.mode !== 'pilot' || typeof value.endsAt !== 'string') return false;
  const endsAt = Date.parse(value.endsAt);
  return Number.isFinite(endsAt) && endsAt > now;
};
